import { createTheme } from "@mui/material/styles";

const get_url = () => {
  if (window.location.hostname.includes("platform.actglobaltrial.com")) {
    if (window.location.hostname.includes("test.platform.actglobaltrial.com")) {
      return "https://testapi.platform.actglobaltrial.com/v1";
    } else if (window.location.hostname.includes("training.platform.actglobaltrial.com")) {
      return "https://api.training.platform.actglobaltrial.com/v1";
    } else if (window.location.hostname.includes("qa.platform.actglobaltrial.com")) {
      return "https://api.qa.platform.actglobaltrial.com/v1";
    } else if (window.location.hostname.includes("migration.platform.actglobaltrial.com")) {
      return "https://migrationapi.platform.actglobaltrial.com/v1";
    } else {
      return "https://api.platform.actglobaltrial.com/v1";
    }
  } else if (window.location.hostname.includes("sctgtrials.com")) {
    if (window.location.hostname.includes("test.platform.sctgtrials.com")) {
      return "https://testapi.platform.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("training.platform.sctgtrials.com")) {
      return "https://api.training.platform.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("qa.platform.sctgtrials.com")) {
      return "https://qa.api.platform.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("plabs.sctgtrials.com")) {
      return "https://api.plabs.sctgtrials.com/v1";
    } else {
      return "https://api.platform.actglobaltrial.com/v1";
    }
  } else {
    return "http://127.0.0.1:3001/v1";
  }
};

const get_corelab_url = () => {
  if (window.location.hostname.includes("platform")) {
    if (window.location.hostname.includes("test")) {
      return "https://staging.api.corelab.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("training")) {
      return "https://training.api.corelab.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("qa")) {
      return "https://qa.api.corelab.sctgtrials.com/v1";
    } else if (window.location.hostname.includes("platform.actglobaltrial.com")) {
      return "https://api.corelab.actglobaltrial.com/v1";
    } else {
      return "https://api.corelab.sctgtrials.com/v1";
    }
  } else if (window.location.hostname.includes("plabs")) {
    return "https://corelabapi.plabs.sctgtrials.com/v1";
  } else {
    return "http://127.0.0.1:8000/v1";
  }
};

export const api_url = get_url();
export const corelab_api_url = get_corelab_url();

export const theme = createTheme({
  mixins: {
    MuiDataGrid: {
      // Pinned columns sections
      pinnedBackground: "#340606",
      // Headers, and top & bottom fixed rows
      containerBackground: "#e9f1fd",
    },
  },
});
